import { Skeleton } from 'components/Skeleton/Skeleton'
import cx from 'classnames'
import Avatar from 'common/Avatar/Avatar'
import { useRequestReadAccess } from 'hooks/queries/articles/useRequestReadAccess'
import Styles from '../CardViewComponent.module.scss'
import { CardViewProps, SkeletonCardProps } from '../cardViewTypes'
import { getDetailsFromBackground } from '../utils/getDetailsFromBackground'
import { InteractionButtons } from './components/InteractionButtons'

export const SplitPaneCardView = (props: CardViewProps) => {
  const {
    disabled,
    selected,
    commentSelected,
    tasks,
    comments,
    mentionSubject,
    subtitle,
    cardStyle,
    articleId,
    loading,
    isError,
  } = props
  const { font, background } = cardStyle
  const details = getDetailsFromBackground(background)
  const [requestReadAccess, requestingAccess] = useRequestReadAccess()
  const backgroundColor = isError ? '#EDEEF0' : background

  if (loading) return <SplitPaneCardSkeleton selected={selected} />

  const subtitleOrRequestAccessLink = () => {
    if (isError && articleId)
      return (
        <span
          className={Styles.requestAccessLink}
          onClick={() => {
            if (requestingAccess) return
            requestReadAccess(articleId)
          }}
        >
          Request access to view
        </span>
      )
    return subtitle
  }

  return (
    <div
      data-test-id="cardViewComponent"
      style={{ background: backgroundColor }}
      className={`${cx(Styles.cardView, Styles.splitPane, {
        [Styles.selected]: selected,
        [Styles.commentSelected]: commentSelected,
        [Styles.restricted]: isError,
        [Styles.boxShadow]: details.includeBoxShadow && !isError,
      })}`}
    >
      <div className={Styles.splitPaneBottom}>
        <div className={Styles.contentContainer}>
          <Avatar className={Styles.avatar} size={70} {...mentionSubject.avatar} />
          <p className={Styles.title} style={{ fontFamily: font }}>
            {mentionSubject.title}
          </p>
          <p className={Styles.subtitle} style={{ fontFamily: font }}>
            {subtitleOrRequestAccessLink()}
          </p>
        </div>
      </div>
      <InteractionButtons disabled={disabled} tasks={tasks} comments={comments} />
    </div>
  )
}

const SplitPaneCardSkeleton = ({ selected }: SkeletonCardProps) => {
  return (
    <div
      data-test-id="cardViewComponent"
      className={`${cx(Styles.cardView, Styles.splitPane, Styles.loading, {
        [Styles.selected]: selected,
      })}`}
    >
      <div className={Styles.splitPaneBottom}>
        <div className={Styles.contentContainer}>
          <Avatar className={Styles.avatar} size={70} />
          <Skeleton className={Styles.title} paragraph={false} title={false} />
          <Skeleton className={Styles.subtitle} paragraph={false} title={false} />
        </div>
      </div>
    </div>
  )
}
